import { render, staticRenderFns } from "./BasicForm.vue?vue&type=template&id=22f6a2bc&scoped=true&"
import script from "./BasicForm.vue?vue&type=script&lang=js&"
export * from "./BasicForm.vue?vue&type=script&lang=js&"
import style0 from "./BasicForm.vue?vue&type=style&index=0&id=22f6a2bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f6a2bc",
  null
  
)

export default component.exports